import { ChangeDetectorRef, Component } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { MbCheckoutStepService } from '../../../services/mb-checkout-step.service'
import {
  MbAcademicDegreesConnector,
  MbCheckoutContactDetailsConnector,
  MbJobTitlesConnector,
  MbSalutationConnector
} from '../../../connectors'
import { BaseSiteService, EventService, GlobalMessageService } from '@spartacus/core'
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'
import { MbCheckoutContactDetailsBase } from '../mb-checkout-contact-details-base'
import { MbCheckoutNavigationService } from '../../../services/mb-checkout-navigation.service'
import { MbCheckoutContactDetailsFacade } from '../../../facades/mb-checkout-contact-details.facade'
import { ActiveCartFacade } from '@spartacus/cart/base/root'

@Component({
  selector: 'mb-checkout-contact-details-us',
  templateUrl: './mb-checkout-contact-details-us.component.html'
})
export class MbCheckoutContactDetailsUsComponent extends MbCheckoutContactDetailsBase {

  constructor (protected activatedRoute: ActivatedRoute,
               protected router: Router,
               protected mbCheckoutStepService: MbCheckoutStepService,
               protected academicDegreesConnector: MbAcademicDegreesConnector,
               protected jobTitlesConnector: MbJobTitlesConnector,
               protected titlesConnector: MbSalutationConnector,
               protected checkoutContactDetailsConnector: MbCheckoutContactDetailsConnector,
               protected activeCartService: ActiveCartFacade,
               protected cdRef: ChangeDetectorRef,
               protected mbCheckoutNavigationService: MbCheckoutNavigationService,
               protected globalMessageService: GlobalMessageService,
               protected mbCheckoutContactDetailsService: MbCheckoutContactDetailsFacade,
               protected baseSiteService: BaseSiteService,
               protected eventService: EventService) {
    super(activatedRoute,
      router,
      mbCheckoutStepService,
      academicDegreesConnector,
      jobTitlesConnector,
      titlesConnector,
      checkoutContactDetailsConnector,
      activeCartService,
      cdRef,
      mbCheckoutNavigationService,
      globalMessageService,
      mbCheckoutContactDetailsService,
      baseSiteService,
      eventService)
  }

  override convertCheckoutContactDetailsModel2Form () {
    this.selectedSalutation = this.contactDetails?.title
    this.selectedAcademicDegree = this.contactDetails?.academicDegree
    this.selectedRole = this.contactDetails?.jobTitle

    return new UntypedFormGroup({
      title: new UntypedFormControl(this.contactDetails?.title, Validators.required),
      academicDegree: new UntypedFormControl(this.contactDetails?.academicDegree),
      firstName: new UntypedFormControl(this.contactDetails?.firstName, Validators.required),
      lastName: new UntypedFormControl(this.contactDetails?.lastName, Validators.required),
      email: new UntypedFormControl(this.getEmailValue(), [Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,63}$')]),
      phoneNumber: new UntypedFormControl(this.contactDetails?.phoneNumber),
      jobTitle: new UntypedFormControl(this.contactDetails?.jobTitle),
      customerNumber: new UntypedFormControl(this.contactDetails?.customerNumber),
    })
  }

  override convertCheckoutContactDetailsForm2Model () {
    this.contactDetails.title = this.contactDetailsForm.get(this.constants.TITLE_CODE)?.value
    this.contactDetails.academicDegree = this.contactDetailsForm.get(this.constants.ACADEMIC_DEGREE_CODE)?.value
    this.contactDetails.firstName = this.contactDetailsForm.get(this.constants.FIRST_NAME_CODE)?.value
    this.contactDetails.lastName = this.contactDetailsForm.get(this.constants.LAST_NAME_CODE)?.value
    this.contactDetails.email = this.contactDetailsForm.get(this.constants.EMAIL_CODE)?.value
    this.contactDetails.phoneNumber = this.contactDetailsForm.get(this.constants.PHONE_NUMBER_CODE)?.value
    this.contactDetails.jobTitle = this.contactDetailsForm.get(this.constants.JOB_TITLE_CODE)?.value
    this.contactDetails.customerNumber = this.contactDetailsForm.get(this.constants.CUSTOMER_NUMBER_CODE)?.value
  }
}
